export default __webpack_public_path__ + "static/media/applePay.9d4cdc2f.svg";